import { getMediaFeatureFlag } from '@atlaskit/media-common';
export var isPreviewableType = function isPreviewableType(type, featureFlags) {
  // in classic experience, only audio/video/image are previewable
  var defaultPreviewableTypes = ['audio', 'video', 'image'];

  // in the new experience, docs are previewable too
  if (getMediaFeatureFlag('newCardExperience', featureFlags)) {
    return [].concat(defaultPreviewableTypes, ['doc']).indexOf(type) > -1;
  }
  return defaultPreviewableTypes.indexOf(type) > -1;
};
export var isMediaCollectionItemFullDetails = function isMediaCollectionItemFullDetails(mediaCollectionItem) {
  return !!mediaCollectionItem['mediaType'] && !!mediaCollectionItem['mimeType'] && !!mediaCollectionItem['processingStatus'];
};
export var DATA_UNIT;
(function (DATA_UNIT) {
  DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
  DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
  DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
})(DATA_UNIT || (DATA_UNIT = {}));